import * as Types from '../constants/actionTypes';
const defaultState = {
    requestRangeList: [],
}
export default (state = defaultState, action) => {
    switch (action.type) {
        // B2C Portal Reception
        case Types.TRACK_NO_DETAILS_SUCCESS:
            return {
                ...state,
                requestIdList: action.requestIdList
            }
        case Types.TRACK_NO_DETAILS_ERROR:
            return {
                ...state,
                requsetIdError: action.requsetIdError
            }
        case Types.PORTAL_STATUS_SUCCESS:
            return {
                ...state,
                portalStageStatList: action.portalStageStatList
            }
        case Types.PORTAL_STATUS_ERROR:
            return {
                ...state,
                portalStageStatError: action.portalStageStatError
            }
        case Types.ASSET_TYPE_SUCCESS:
            return {
                ...state,
                assetTypeList: action.assetTypeList
            }
        case Types.ASSET_TYPE_ERROR:
            return {
                ...state,
                assetTypeError: action.assetTypeError
            }

        // B2C Portal Reports
        case Types.REQUEST_DETAIL_RANGE_SUCCESS:
            return {
                ...state,
                requestRangeList: action.requestRangeList
            }
        case Types.REQUEST_DETAIL_RANGE_ERROR:
            return {
                ...state,
                requestRangeError: action.requestRangeError
            }
        case Types.REPORT_DOC_SUCCESS:
            return {
                ...state,
                requestDocList: action.requestDocList
            }
        case Types.REPORT_DOC_ERROR:
            return {
                ...state,
                requestDocError: action.requestDocError
            }
        case Types.REPORT_DOC_DELETED:
            return {
                ...state,
                requestDocList: action.requestDocList
            }
        default:
            return state
    }
}
